<template>
    <div>
        <el-drawer ref="qiyeDraw" title="账单明细" :visible.sync="isShow" size="900px" @close="handleClose">
            <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
                <el-form-item label="订单号" prop="orderNo">
                    <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="入住人" prop="customerName">
                    <el-input v-model="searchForm.customerName" placeholder="请输入入住人" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="searchForm.status" placeholder="请选择" style="width: 120px">
                        <el-option label="已入住" :value="4"></el-option>
                        <el-option label="已退房" :value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="#" align="center"></el-table-column>
                <el-table-column prop="createTime" label="预定时间" width="150"></el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
                <el-table-column prop="payWayDesc" label="支付方式" width="120"></el-table-column>
                <el-table-column prop="lastPay" label="价格" width="120"></el-table-column>
                <el-table-column prop="enterContact" label="预定人" width="120"></el-table-column>
                <el-table-column prop="customerName" label="入住人" width="120"></el-table-column>
                <el-table-column prop="customerMobile" label="手机号" width="120"></el-table-column>
                <el-table-column prop="roomTypeName" label="房型" width="120"></el-table-column>
                <el-table-column prop="days" label="预定天数" width="120"></el-table-column>
                <el-table-column prop="estimatedCheckIn" label="入住时间" width="120"></el-table-column>
                <el-table-column prop="estimatedCheckOut" label="离店时间" width="120"></el-table-column>
                <el-table-column prop="statusDesc" label="状态"  width="130">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" v-if="row.status == 6">{{ row.statusDesc }}</el-tag>
                        <el-tag v-else>{{ row.statusDesc }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage" style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </el-drawer>
    </div>
</template>


<script>
import { deepClone } from '@/utils/util'
export default {
    props: {
        isOrderDetail: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
        enterpriseId: {
            type: String,
            default: '',
        },
        propData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        headers() {
            return {
                Authorization: localStorage.getItem("Token"),
            };
        },
    },
    data() {
        return {
            isShow: false,
            searchForm: {
                orderNo: "",
                status: 4,
                customerName: '',
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            tableData: [],
            total: 0,
            selectTime: [],
            isAdd: false,
            modelForm: {
                
            },
            imgUrl: "",
            submitLoading: false,
        };
    },
    watch: {
        isOrderDetail(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    orderNo: "",
                    status: 4,
                    customerName: '',
                    pageNumber: 1,
                    pageSize: 10,
                };
                this.getTableData();
            }
        },
    },
    methods: {
        handleClose() {
            this.isShow = false;
            this.$emit('update:isOrderDetail', this.isShow)
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                orderNo: "",
                status: 4,
                customerName: '',
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.searchForm.enterpriseId = this.enterpriseId;
            this.searchForm.customerMobile = this.propData.phone ? this.propData.phone : '',
            this.getRequest("/api/roomOrder/page2", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
        
    },
};
</script>

<style lang="less">

</style>